import { observable, action, toJS, decorate } from 'mobx'

class Login {
    link = ''

    setReturnTo (link) {
      this.link = link
    }

    getRedirectURL () {
      return toJS(this.link)
    }
}

decorate(Login, {
  link: observable,
  setReturnTo: action,
  getRedirectURL: action
})

export default new Login()
